import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(null);
    const dest = user?.role === "school" ? "/escola/login" : "/login";
    window.location.href = dest;
  };

  const isAdmin = user?.role === "admin";
  const isSchool = user?.role === "school";

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, checkAuth, logout, isAdmin, isSchool }}>
      {children}
    </AuthCtx.Provider>
  );
};
